import { useFormikContext } from 'formik';
import { DynamicArray, DynamicArrayProps } from 'factories/DynamicArray';

interface FormikDynamicArrayProps extends Omit<DynamicArrayProps, 'error'> {
  name: string;
}

export const FormikDynamicArray: React.FC<FormikDynamicArrayProps> = ({
  name,
  ...props
}) => {
  const { errors, touched } = useFormikContext();

  // Gestion des erreurs pour les champs de tableau
  const getFieldError = () => {
    const fieldError = (errors as any)[name];
    const fieldTouched = (touched as any)[name];

    if (fieldTouched && fieldError) {
      if (typeof fieldError === 'string') {
        return fieldError;
      }
      // Si c'est un tableau d'erreurs, on prend la première erreur non-null
      if (Array.isArray(fieldError)) {
        const firstError = fieldError.find(err => err && typeof err === 'string');
        return firstError;
      }
    }

    return '';
  };

  return (
    <DynamicArray
      {...props}
      name={name}
      error={getFieldError()}
    />
  );
};
